import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NeveMeasurementsTableComponent } from './neve-measurements-table.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedProviderModule } from '~app/shared/shared.module';
import { QmDirectivesModule } from '~app/components/qm-directives/qm-directives.module';
import { QmPipesModule } from '~app/components/qm-pipes/qm-pipes.module';

@NgModule({
  declarations: [NeveMeasurementsTableComponent],
  imports: [ CommonModule, SharedProviderModule, TranslateModule, NgbNavModule, QmDirectivesModule, QmPipesModule, NgbTooltipModule ],
  exports: [NeveMeasurementsTableComponent],
  providers: [],
})
export class NeveMeasurementsModule {}
